import { useAtom } from "jotai";
import { allWorkSchedulesAtom } from "./FetchAllWorkScheduleConfigs";
import {
  TOOLTIP_PROPS,
  customerTilesPopupDataAtom,
} from "./internalToolsUtils";
import { IconButton, Tooltip } from "@mui/material";
import { AirplaneTicket, PunchClock, Style } from "@mui/icons-material";
import { parseFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";
import { allFlightConfigsAtom } from "./FetchAllFlightConfigs";
import { customerInfoJsonAtom } from "reports/utils/hooks/useCustomerInfoJson";
import styled from "styled-components/macro";
import { useState } from "react";

export const InspectCustomerConfigsDropdown = ({ ckey }: { ckey: string }) => {
  const [allFlightConfigs] = useAtom(allFlightConfigsAtom);
  const [, setCustomerTilesPopupData] = useAtom(customerTilesPopupDataAtom);
  let flightConfig = allFlightConfigs[ckey];

  const [hovered, setHovered] = useState(false);

  return (
    <Styles
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      <Tooltip title="🔍 Flight Config" {...TOOLTIP_PROPS}>
        <IconButton
          onMouseEnter={() => {
            setHovered(true);
          }}
          style={!flightConfig ? { opacity: 0.2 } : {}}
          size="small"
          className="btnSearch"
          onClick={e => {
            e.stopPropagation();
            try {
              flightConfig = parseFlightConfig(flightConfig);
            } catch (err) {
              console.error("Error parsing flightConfig", err);
            }
            setCustomerTilesPopupData({
              popupData: flightConfig,
              ckey,
              adminUrls: [
                {
                  url: `https://portal.raven.ai/${ckey}/flightConfig/`,
                  name: "Flight Config",
                },
              ],
            });
            console.log("🔍: ", flightConfig);
          }}
        >
          <AirplaneTicket />
        </IconButton>
      </Tooltip>

      {hovered ? (
        <>
          <InspectCustomerInfoButton ckey={ckey} />
          <InspectWorkSchedulesConfigButton ckey={ckey} />
        </>
      ) : null}
    </Styles>
  );
};
const Styles = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 20px;
  overflow: visible;
  button {
    background: rgba(255, 255, 255, 0.8);
  }
`;

function InspectCustomerInfoButton({ ckey }: { ckey: string }) {
  const customerJson = useAtom(customerInfoJsonAtom)[0][ckey];
  const [, setCustomerTilesPopupData] = useAtom(customerTilesPopupDataAtom);
  return (
    <Tooltip title="🔍 Customer Info" {...TOOLTIP_PROPS}>
      <IconButton
        style={!customerJson ? { opacity: 0.2 } : {}}
        size="small"
        className="btnSearch"
        onClick={e => {
          e.stopPropagation();
          setCustomerTilesPopupData({
            popupData: customerJson,
            ckey,
            adminUrls: [
              {
                url: `https://${ckey}.gke-us-east1.raven-cloud.com/midgard/admin/customer_info/customerinfojson/`,
                name: "Customer Info",
              },
            ],
          });
          console.log("🔍: ", customerJson);
        }}
      >
        <Style />
      </IconButton>
    </Tooltip>
  );
}

function InspectWorkSchedulesConfigButton({ ckey }: { ckey: string }) {
  const [allWorkSchedules] = useAtom(allWorkSchedulesAtom);
  const [, setCustomerTilesPopupData] = useAtom(customerTilesPopupDataAtom);
  const workSchedulesConfig = allWorkSchedules[ckey];

  return (
    <Tooltip title="🔍 Work Schedules Config" {...TOOLTIP_PROPS}>
      <IconButton
        style={!workSchedulesConfig ? { opacity: 0.2 } : {}}
        size="small"
        className="btnSearch"
        onClick={e => {
          e.stopPropagation();
          setCustomerTilesPopupData({
            popupData: workSchedulesConfig,
            ckey,
            adminUrls: [
              {
                url: `https://${ckey}.gke-us-east1.raven-cloud.com/midgard/admin/deployment_config/workscheduleconfig/`,
                name: "Work Schedule Config",
              },
            ],
          });
          console.log("🔍: ", workSchedulesConfig);
        }}
      >
        <PunchClock />
      </IconButton>
    </Tooltip>
  );
}
